import Structure from 'components/REDL/Structure';
import BlocREDLWrapper from '../BlocREDLWrapper';
import { useDelivertyUser } from 'hooks/useDelivertyUser';
import Head from 'next/head'; // Afegit

export default function ZonaEditable(props) {
    const { isEditModeEnable } = useDelivertyUser();

    return <>{isEditModeEnable ? <BlocREDLWrapper {...props} /> : <Structure {...props} />}</>;
}
